<template>
  <div class="container mb-5">
    <div class="row mb-5 my-md-5">
      <div class="col-sm-6 offset-sm-3">
        <h1 class="text-center">
          {{ $t("receita", 2) }}
        </h1>
      </div>
    </div>
    <ReceitasTable />
  </div>
</template>

<script>
import ReceitasTable from './components/ReceitasTable.vue';

export default {
  components: { ReceitasTable },
};
</script>
